module.exports = {
	"id": "HN",
	"name": "Honduras",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.03952,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.0247,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.02964,
			"23": null,
			"24": 0.00494,
			"25": null,
			"26": 0.00988,
			"27": 0.00494,
			"28": 0.00494,
			"29": 0.00988,
			"30": 0.00494,
			"31": 0.0247,
			"32": 0.00988,
			"33": 0.00988,
			"34": 0.02964,
			"35": 0.0247,
			"36": 0.03458,
			"37": 0.01976,
			"38": 0.03952,
			"39": 0.03458,
			"40": 0.03458,
			"41": 0.01976,
			"42": 0.01482,
			"43": 0.09386,
			"44": 0.06916,
			"45": 0.0247,
			"46": 0.03458,
			"47": 0.05928,
			"48": 0.11856,
			"49": 1.51164,
			"50": 0.16302,
			"51": 0.40014,
			"52": 0.47424,
			"53": 22.78822,
			"54": 6.9407,
			"55": 0.06422,
			"56": 0.01976,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.01976,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": 0.01482,
			"13": null,
			"14": null,
			"15": null,
			"16": 0.02964,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": 0.00988,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.00494,
			"30": null,
			"31": null,
			"32": null,
			"33": 0.00494,
			"34": null,
			"35": 0.00988,
			"36": 0.00988,
			"37": 0.00988,
			"38": 0.0247,
			"39": 0.03952,
			"40": 0.02964,
			"41": 0.03458,
			"42": 0.01482,
			"43": 0.07904,
			"44": 0.0247,
			"45": 0.08892,
			"46": 0.03458,
			"47": 0.28652,
			"48": 0.26182,
			"49": 4.0508,
			"50": 0.0247,
			"51": 0.00494,
			"52": null,
			"3.5": 0.00988,
			"3.6": 0.00988
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": 0.01482,
			"28": null,
			"29": 0.18278,
			"30": null,
			"31": null,
			"32": null,
			"33": 0.06422,
			"34": null,
			"35": 0.00988,
			"36": 0.0247,
			"37": 0.25688,
			"38": 0.01976,
			"39": 0.00988,
			"40": 0.49894,
			"41": 0.0741,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.00988
		},
		"safari": {
			"0": null,
			"4": 0.00494,
			"5": 0.00988,
			"6": null,
			"7": null,
			"8": 0.0988,
			"9": 0.16796,
			"10": 0.75088,
			"3.1": null,
			"3.2": null,
			"5.1": 0.01976,
			"6.1": 0.0247,
			"7.1": 0.00988,
			"9.1": 0.56316
		},
		"ios_saf": {
			"8": 0,
			"10": 2.85367568693,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0769032577019,
			"8.1-8.4": 0.142075509992,
			"9.0-9.2": 0.0677791423813,
			"9.3": 1.034066403
		},
		"android": {
			"3": 0,
			"4": 0.162273023256,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.020284127907,
			"4.1": 0.585341976744,
			"4.2-4.3": 1.46335494186,
			"4.4": 3.35557430233,
			"4.4.3-4.4.4": 3.38455162791
		},
		"ie": {
			"6": 0.00506775862069,
			"7": null,
			"8": 0.233116896552,
			"9": 0.126693965517,
			"10": 0.126693965517,
			"11": 1.27200741379,
			"5.5": null
		},
		"op_mob": {
			"0": 0.158074796152,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00439096655978
		},
		"edge": {
			"12": 0.13832,
			"13": 0.3211,
			"14": 0.46436
		},
		"ie_mob": {
			"10": 0.100772394366,
			"11": 0.410287605634
		},
		"bb": {
			"7": 0.10626,
			"10": null
		},
		"samsung": {
			"0": 4.14414
		},
		"and_uc": {
			"0": 1.1385
		},
		"op_mini": {
			"0": 2.12971423729
		},
		"and_chr": {
			"0": 33.78008
		},
		"and_ff": {
			"0": 0.00506
		}
	},
	"total": 98.95084
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/HN.json
 ** module id = 543
 ** module chunks = 0
 **/